/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
import Vue from 'vue'
let pdfPaperPileApiURL = root.pdfPaperPileApiUrl.link;
let searchPaperPileApiURL = root.searchPaperPileApiUrl.link;
let researchGroupForAwerackApiURL = root.researchGroupForAwerackApiUrl.link;
let bucketForAwerackApiURL = root.bucketForAwerackApiUrl.link;
let commentOnResearchGroupApiURL = root.commentOnResearchGroupApiUrl.link;
let notesOfPdfApiURL = root.notesOfPdfApiUrl.link;
let updateNotesOfPdfApiUrl = root.updateNotesOfPdfApiUrl.link;
let favouritePaperListApiUrl = root.favouritePaperListApiUrl.link;
let trashPaperListApiUrl = root.trashPaperListApiUrl.link;
let trashFolderListApiUrl = root.trashFolderListApiUrl.link;
let awerackPaperSharedApiUrl = root.awerackPaperSharedApiUrl.link;
let trashPaperRestoreApiUrl = root.trashPaperRestoreApiUrl.link;
let sharedPaperListApiUrl = root.sharedPaperListApiUrl.link;
let allTrashClearApiUrl = root.allTrashClearApiUrl.link;

export default {
  state: {
    getPaperPileListState:{},
    getResearchGroupForAwerackState:{},
    getBucketListOfAwerackState:{},
    getBucketDetailByIdOfAwerackState:{},
    getResearchGroupDetailByIdState:{},
    getFavouritePaperListState:{},
    getTrashaperListState:{},
    getTrashFolderListState:{},
    getSharedPaperListState:{}
  },
  mutations: {
    getPaperPileListMutation(state, value) {
      Vue.set(state, 'getPaperPileListState', value);
    },
    getResearchGroupForAwerackMutation(state, value) {
      Vue.set(state, 'getResearchGroupForAwerackState', value);
    },
    getBucketListOfAwerackMutation(state, value) {
      Vue.set(state, 'getBucketListOfAwerackState', value);
    },
    getBucketDetailByIdOfAwerackMutation(state, value) {
      Vue.set(state, 'getBucketDetailByIdOfAwerackState', value);
    },
    getResearchGroupDetailByIdMutation(state, value) {
      Vue.set(state, 'getResearchGroupDetailByIdState', value);
    },
    getFavouritePaperListMutation(state, value) {
      Vue.set(state, 'getFavouritePaperListState', value);
    },
    getTrashaperListMutation(state, value) {
      Vue.set(state, 'getTrashaperListState', value);
    },
    getTrashFolderListMutation(state, value) {
        Vue.set(state, 'getTrashFolderListState', value);
    },
    getSharedPaperListMutation(state, value) {
        Vue.set(state, 'getSharedPaperListState', value);
    }
  },
  actions: {
    clearAllTrashOfPapperFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(allTrashClearApiUrl).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Shared Paper List Function
    getSharedPaperListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(sharedPaperListApiUrl).then(res => {
                context.commit('getSharedPaperListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Trash Folder List Function
    getTrashFolderListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(trashFolderListApiUrl).then(res => {
                context.commit('getTrashFolderListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Trash Paper Restore Function
    trashPaperRestoreFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(trashPaperRestoreApiUrl + payload.id + '/').then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Paper Shared Function
    sharedPaperUserFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(awerackPaperSharedApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Trash Paper List Function
    getTrashPaperListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(trashPaperListApiUrl).then(res => {
                context.commit('getTrashaperListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Favourite Paper List Function
    getFavouritePaperListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(favouritePaperListApiUrl).then(res => {
                context.commit('getFavouritePaperListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    getNotesToPdfFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(notesOfPdfApiURL + '?pdf_paper=' + payload.id).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    createNewNotesForPdfFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(notesOfPdfApiURL,payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    updateNotesInfoOfPdfFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(updateNotesOfPdfApiUrl + payload.data.id + '/', payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // create Comment For Research Group Function
    createCommentForResearchGroupFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(commentOnResearchGroupApiURL,payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Bucket Details By ID Of Awerack Function
    getBucketDetailsByIdOfAwerackFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(bucketForAwerackApiURL + payload.id + '/').then(res => {
                context.commit('getBucketDetailByIdOfAwerackMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Update Bucket Details Of Awerack Function
    updateBucketOfAwerackDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(bucketForAwerackApiURL + payload.data.id + '/', payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Remove Bucket Details Of Awerack Function
    removeBucketOfAwerackDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(bucketForAwerackApiURL + payload.id + '/').then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Create Bucket Details Of Awerack Function
    createBucketOfAwerackDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(bucketForAwerackApiURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Bucket List Of Awerack Function
    getBucketListOfAwerackFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(bucketForAwerackApiURL, payload).then(res => {
                context.commit('getBucketListOfAwerackMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Research Group Details Function
    createResearchGroupDetailsFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(researchGroupForAwerackApiURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Research Group List Function
    getResearchGroupListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(researchGroupForAwerackApiURL, payload).then(res => {
                context.commit('getResearchGroupForAwerackMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Research Group Details By ID Function
    getResearchGroupDetailsByIDFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(researchGroupForAwerackApiURL + payload.id + '/').then(res => {
                context.commit('getResearchGroupDetailByIdMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Update Research Group Details By ID Function
    updateResearchGroupDetailsByIDFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(researchGroupForAwerackApiURL + payload.data.id + '/', payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Search Paperpile Function
    searchPaperPileFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(searchPaperPileApiURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get All PaperPile Function
    getAllPaperPileFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(pdfPaperPileApiURL + '?page_size=15', payload).then(res => {
                context.commit('getPaperPileListMutation', res.data);
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    createNewPaperPileFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(pdfPaperPileApiURL, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    removePaperInAwerackFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(pdfPaperPileApiURL+ payload.id + '/').then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    updatePaperPileDetailsByIdFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(pdfPaperPileApiURL + payload.data.id + '/', payload.data.data).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    removeAwerackPaperFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(researchGroupForAwerackApiURL + payload.id + '/').then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
  },
  getters: {
    getPaperPileListGetters : state => state.getPaperPileListState,
    getResearchGroupForAwerackGetters : state => state.getResearchGroupForAwerackState,
    getBucketListOfAwerackGetters : state => state.getBucketListOfAwerackState,
    getBucketDetailByIdOfAwerackGetters : state => state.getBucketDetailByIdOfAwerackState,
    getResearchGroupDetailByIdGetters : state => state.getResearchGroupDetailByIdState,
    getFavouritePaperListGetters: state => state.getFavouritePaperListState,
    getTrashaperListGetters: state => state.getTrashaperListState,
    getTrashFolderListGetters: state => state.getTrashFolderListState,
    getSharedPaperListGetters: state => state.getSharedPaperListState
  }
}